import {yupResolver} from '@hookform/resolvers/yup'
import React, {lazy, Suspense} from 'react'
import {FieldValues, FormProvider as ReactHookFormProvider, useForm} from 'react-hook-form'

import type {Props} from './FormProvider.types'

const LazyDevTool = lazy(() => import('@hookform/devtools').then(({DevTool}) => ({default: DevTool})))

export function FormProvider<FormValues extends FieldValues>({
  children,
  validationSchema,
  debug,
  ...params
}: Props<FormValues>) {
  const resolver = validationSchema
    ? yupResolver(
        validationSchema,
        {},
        {
          mode: 'async',
        },
      )
    : undefined

  const methods = useForm<FormValues>({resolver, mode: 'onBlur', ...params})
  let devToolNode: React.ReactNode = null

  if (process.env.NODE_ENV === 'development') {
    if (debug) {
      devToolNode = (
        <Suspense fallback={null}>
          <LazyDevTool control={methods.control} />
        </Suspense>
      )
    }
  }

  return (
    <>
      <ReactHookFormProvider<FormValues> {...methods}>{children}</ReactHookFormProvider>
      {devToolNode}
    </>
  )
}
